module.exports = __webpack_public_path__ + "static/media/EthicalAI.4618243f.jpg";